import { z } from 'zod'

export const NotificationParameter = z.object({
  name: z.string(),
  description: z.string(),
  example: z.string().optional(),
})

export const NotificationEvent = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string(),
  defaultTemplate: z.string(),
  parameters: z.array(NotificationParameter),
  hasCustomTemplate: z.boolean(),
  isDisabled: z.boolean(),
})

export const NotificationTemplate = z.object({
  eventId: z.string(),
  notificationType: z.enum(['telegram', 'slack']),
  template: z.string(),
  isCustom: z.boolean(),
  isActive: z.boolean(),
  parameters: z.array(NotificationParameter),
})

export const notificationTypeQuerySchema = z.object({
  type: z.enum(['telegram', 'slack']).default('telegram'),
})

export type NotificationEventType = z.infer<typeof NotificationEvent>
export type NotificationTemplateType = z.infer<typeof NotificationTemplate>
